import {Component, OnInit} from '@angular/core';
import {ProgressIndicatorService} from '../../../@shared';
import {HttpResponseDto, QuotationControllerService, RfqDto, RfqRequestDto} from '../../../@api';
import {MessagingHandlerService} from '../../../common/response-messaging-handler/messaging-handler.service';
import {Router} from '@angular/router';
import {v4 as uuidv4} from 'uuid';
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'secure-dashboard-content',
    templateUrl: './dashboard-content.component.html',
    styleUrls: ['./dashboard-content.component.scss']
})
export class DashboardContentComponent implements OnInit {

    rfqTotal: number;
    quotationTotal: number = 0;
    orderTotal: number = 0;
    uuid!: string;

    constructor(private progressIndicatorService: ProgressIndicatorService,
                private quotationService: QuotationControllerService,
                private messageService: MessagingHandlerService,
                private router: Router) {
        console.log('DashboardContentComponent constructor()');
        this.showProgress();
    }

    ngOnInit(): void {
        this.uuid = uuidv4();
        this.quotationService.findRfqRecordTotal().subscribe((response: HttpResponseDto): void => {
            this.rfqTotal = Number(response.data);
            this.hideProgress(1000);
        }, error => {
            console.log(error);
            this.hideProgress(500);
        });
    }

    showProgress(): void {
        this.progressIndicatorService.publish(true);
    }

    hideProgress(delay: number = 100): void {
        setTimeout((): void => {
            this.progressIndicatorService.publish(false);
        }, delay);
    }

    newRfq(): void {
        let rfqRequestJson: string = '{' +
            '  "id": 0,' +
            '  "uid": "",' +
            '  "profile": "solarcentral.co.za",' +
            '  "dailyKwUsage": 30.576,' +
            '  "day": 40,' +
            '  "night": 60,' +
            '  "dayKwUsage": 12.288,' +
            '  "nightKwUsage": 18.288,' +
            '  "information": "Change status to CREATED to generate quotations.",' +
            '  "householdSize": "3-4",' +
            '  "provinceId": "3",' +
            '  "regionId": "6",' +
            '  "fullName": "Ramon Fourie",' +
            '  "phone": "0829693231",' +
            '  "email": "ramon.fourie@icloud.com",' +
            '  "contact": "Afternoon",' +
            '  "importance": "Reduce electricity bills",' +
            '  "coverage": 80,' +
            '  "status": "COMPLETE",' +
            '  "property": {' +
            '    "storeys": "single",' +
            '    "roofType": "Tile",' +
            '    "roofDirection": "North",' +
            '    "panelsToInverter": "30",' +
            '    "inverterToDb": "30"' +
            '  }' +
            '}';
        let rfqRequestDto: RfqRequestDto = JSON.parse(rfqRequestJson);
        rfqRequestDto.uid = this.uuid;

        this.showProgress();
        this.quotationService.newRfqRequest(rfqRequestDto).subscribe((response: HttpResponseDto): void => {
            let rfq: any = JSON.parse(response.data);
            this.quotationService.findRfqByUid(rfq.uid).subscribe((newRfqDto: RfqDto): void => {
                newRfqDto.status = 'COMPLETE';
                this.quotationService.updateRfq(Object.assign({}, newRfqDto)).subscribe((updatedRfqDto: RfqDto): void => {
                    this.hideProgress();
                    this.messageService.showSuccess('New RFQ created', updatedRfqDto.number);
                    this.router.navigate(['/secure/dashboard/rfqs/' + updatedRfqDto.number]).then((_: boolean): void => {});
                }, e3 => {
                    this.hideProgress();
                    console.log(JSON.stringify(e3));
                    this.messageService.showError('Could not update RFQ to COMPLETE after successfully created.', 'Request Failed');
                });
            }, e1 => {
                this.hideProgress();
                console.log(JSON.stringify(e1));
                this.messageService.showError('Could not load RFQ after successfully created.', 'Request Failed');
            });
        }, e0 => {
            console.log(JSON.stringify(e0));
            this.hideProgress();
            this.messageService.showError('Could not create new RFQ.', 'Request Failed');
        });
    }
}
